export const localStorageKeys = {
	showBankToast: 'showBankToast'
}
